/* eslint-disable react/prop-types */
import React from 'react';
import { withRouter } from 'react-router-dom';
import Scrollbar from 'smooth-scrollbar';

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    let bodyScrollBar = Scrollbar.get(document.body);

    if (this.props.location !== prevProps.location) {
      bodyScrollBar.scrollTo(0, 0, 700);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./scripts/components/Global/ScrollToTop.jsx